import {
  CiselnikPolozka,
  CiselnikPolozkaExternalApi,
  TypCiselnikaEnum,
} from 'ciselniky-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { ciselnikyPrefixPath } from '../../configuration/apiConfigurationConstants';
import PolozkaCiselnik from '../../../model/ciselniky/PolozkaCiselnik';

const client = new CiselnikPolozkaExternalApi(apiConfiguration(ciselnikyPrefixPath));

function map(polozky: CiselnikPolozka[]): PolozkaCiselnik[] {
  return polozky.map(polozka => ({
    uuid: polozka.uuid,
    nazov: polozka.nazov,
    platny: polozka.platny,
    kod: polozka.kod,
    legislativny: polozka.legislativny,
    existujeFormular: polozka?.existujeFormular,
    generovanySystemom: polozka?.generovanySystemom,
    povolitZadavanieFormularom: polozka?.povolitZadavanieFormularom,
  }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchCiselnikPolozky = async (
  ids: string[],
  typy: TypCiselnikaEnum[],
  platny: boolean,
  hladanyNazov: string,
  kody: string[],
  limit: number,
  // eslint-disable-next-line default-param-last
  execute = true,
  headers?: object,
):
  Promise<ClientResponse<PolozkaCiselnik[]>> => {
  if (!execute) {
    return {
      data: [],
      responseCode: null,
    };
  }
  const {
    data,
    status,
  } = await client.getCiselnikPolozka(ids, typy, platny, hladanyNazov, kody, limit, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
